import {useEffect, useRef, useState} from "react";
import config from "../../config/apiService.json";
import fetchData from "../../utils/fetchData";
import {toast} from "react-toastify";
import {imageFileTypeValidation, validateImageSize} from "../../utils/imageValidation";
import {fileTypePdfOrNot} from "../../utils/fileTypeValidityCheckService";
import {deleteMethod, patchMethod, postMethod} from "../../utils/httpServices";
import Swal from "sweetalert2";
import defaultIcon from "../../assets/images/deafult/default-small-image.png";

const UseGuidelines = () => {
  const modalCloseIconButton = useRef();
  const iconInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [demoGuidelineObj, setDemoGuidelineObj] = useState({
    "titleEn": "",
    "icon": null,
    "backgroundColor": "#313131",
    "pdfEn": null
  });
  const [pdfFile, setPdfFile] = useState();
  const [iconFile, setIconFile] = useState();
  const [modalPdfFile, setModalPdfFile] = useState();
  const [modalIconFile, setModalIconFile] = useState();
  const {guidelines, administrative} = config;

  const titleMaxSize = 22;

  const getData = async () => {
    const result = await fetchData(guidelines);
    setData(result);
    setLoading(false);
  }

  const handleChange = (e, id) => {
    const {name, value} = e.target;
    const updatedData = data.map(d => {
      if (d.id === id) {
        d[name] = value
      }
      return d;
    });
    setData(updatedData);
    if (value.length >= titleMaxSize)
      toast.warn(`Maximum ${titleMaxSize} characters!`);
  }

  const handleIconChange = (e, id) => {
    const file = e.target.files[0];
    if (file) {
      let imageSizeValidityResult = validateImageSize(file, 300);
      let imageValidityResult = imageFileTypeValidation(file);

      if (imageSizeValidityResult === true && imageValidityResult === true) {
        setIconFile(file);
        updateIcon(file, id);
      }
    }
  }

  const updateIcon = async (file, id) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      let base64 = reader.result.replace(`data:${file.type};base64,`, "");
      const updatedData = data.map(d => {
        if (d.id === id) {
          d.iconBase64 = base64;
          d.iconTag = file.name;
        }
        return d;
      });
      setData(updatedData);
    };
  }

  const handlePdfFileChange = (e, id) => {
    const file = e.target.files[0];
    if (file) {
      const fileTypePdfOrNotResult = fileTypePdfOrNot(file);
      if (fileTypePdfOrNotResult) {
        const modifiedData = data.map(d => {
          if (d.id === id) {
            d.pdfEnTag = file.name;
          }
          return d;
        });
        setData(modifiedData);
        setPdfFile(file);
      }
    }
  }

  const handleUpdate = async (id) => {
    let updatedData = data.filter(d => d.id === id);
    updatedData = updatedData[0];

    const formData = new FormData();
    iconFile && formData.append('icon', iconFile);
    formData.append('titleEn', updatedData.titleEn);
    formData.append('backgroundColor', updatedData.backgroundColor);
    pdfFile && formData.append('pdfEn', pdfFile);

    try {
      const response = await patchMethod(`${administrative.guidelines}/${id}`, formData);
      if (response) {
        toast.success("Guideline Updated!");
        getData();
        setPdfFile(null);
        setIconFile(null);
      }
    } catch (ex) {
      toast.error(ex.response.data);
    }
  }

  const handleDelete = (id) => {
    try {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#354e80',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await deleteMethod(`${administrative.guidelines}/${id}`);
          if (response) {
            let updatedData = data.filter(d => d.id !== id);
            setData(updatedData);
            Swal.fire(
                'Deleted!',
                'Your file has been deleted.',
                'success'
            )
          }
        }
      });
    } catch (ex) {
      toast.error(ex.response.data);
    }
  }

  // for add guidelines
  const handleModalChange = (e) => {
    const {name, value} = e.target;
    setDemoGuidelineObj({...demoGuidelineObj, [name]: value});
    if (value.length >= titleMaxSize)
      toast.warn(`Maximum ${titleMaxSize} characters!`);
  }

  const handleModalIconChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      let imageSizeValidityResult = validateImageSize(file, 300);
      let imageValidityResult = imageFileTypeValidation(file);

      if (imageSizeValidityResult === true && imageValidityResult === true) {
        setModalIconFile(file);
        updateModalIcon(file);
      }
    }
  }

  const updateModalIcon = async (file) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      let base64 = reader.result.replace(`data:${file.type};base64,`, "");
      setDemoGuidelineObj({...demoGuidelineObj, icon: base64})
    };
  }

  const handleModalPdfFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileTypePdfOrNotResult = fileTypePdfOrNot(file);
      if (fileTypePdfOrNotResult) {
        setModalPdfFile(file);
        setDemoGuidelineObj({...demoGuidelineObj, file: file.name})
      }
    }
  }

  const handleModalUpdate = async () => {
    const formData = new FormData();
    modalIconFile && formData.append('icon', modalIconFile);
    formData.append('titleEn', demoGuidelineObj.titleEn);
    formData.append('backgroundColor', demoGuidelineObj.backgroundColor);
    modalPdfFile && formData.append('pdfEn', modalPdfFile);

    try {
      const response = await postMethod(`${administrative.guidelines}`, formData);
      if (response) {
        toast.success("Guideline Added!");
        getData();
        setModalPdfFile(null);
        setModalIconFile(null);
        setDemoGuidelineObj({
          "titleEn": "",
          "icon": null,
          "backgroundColor": "#313131",
          "pdfEn": null
        });
        modalCloseIconButton.current.click();
      }
    } catch (ex) {
      toast.error(ex.response.data);
    }
  }

  const handleCloseModal = () => {
    iconInputRef.current.value = "";
    fileInputRef.current.value = "";
    setDemoGuidelineObj({
      "titleEn": "",
      "icon": null,
      "backgroundColor": "#313131",
      "pdfEn": null
    });
  };

  useEffect(() => {
    getData();
  }, []);

  return {
    data,
    isLoading,
    demoGuidelineObj,
    handleDelete,
    handleUpdate,
    handleChange,
    handleIconChange,
    handlePdfFileChange,
    handleModalIconChange,
    handleModalChange,
    handleModalPdfFileChange,
    handleModalUpdate,
    handleCloseModal,
    fileInputRef,
    iconInputRef,
    modalCloseIconButton
  };
};

export default UseGuidelines;
